"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackProduct = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackProduct(product, baseUrl) {
    if (!product) {
        return;
    }
    (0, pushToDataLayer_1.pushToDataLayer)({
        Product: {
            ID: product.trackingName,
            manufacturerSKU: product.manufacturerSku,
            URL: baseUrl + product.url,
            title: product.title,
            imageURL: product.images && product.images.length > 0 ? product.images[0].absoluteUrl : '',
            price: product.price.gross.amount,
            currency: product.price.gross.currencyCode,
            category: product.trackingPath.length > 1
                ? product.trackingPath[product.trackingPath.length - 1]
                : '',
            categoryMain: product.trackingPath.length > 0 ? product.trackingPath[0] : '',
        },
    });
}
exports.trackProduct = trackProduct;
//# sourceMappingURL=trackProduct.js.map